import {Alert} from './alert';

export const Permissions = {Alert};
